module.exports = __webpack_public_path__ + "img/icon-play.109913e5.svg";